export default "__VITE_ASSET__DjpLkDUU__"